// import Vue from "vue";
// import App from "./App.vue";
// import router from "./router";
// import store from "./store/index";
// import config from "./config.js";
// import { browserTitle } from "./utils/utils.js";
// import Card from "./components/card/index.js";
// import VueClipboard from "vue-clipboard2";
// import "./registerServiceWorker";
// import nanoId from "nanoid";
// // import getUserInfo from "./utils/getUserInfo.js";
// import i18n from "./locale/i18n.js";
// import events from "./utils/event.js";
// const siteConfig = config[process.env.NODE_ENV];

// Vue.use(VueClipboard);

// import GelatinUi from "gelatin-ui";
// Vue.use(GelatinUi, {
//   zIndex: 1000
// });

// Vue.config.productionTip = false;
// Vue.prototype.$title = browserTitle;

// new Vue({
//   i18n,
//   router,
//   store,
//   render: h => h(App)
// }).$mount("#app");

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import VueClipboard from "vue-clipboard2";
import GelatinUi from "gelatin-ui";
import i18n from "./locale/i18n.js";
import { browserTitle } from "./utils/utils.js";
import nanoId from "nanoid";

Vue.use(VueClipboard);
Vue.use(GelatinUi, {
  zIndex: 1000
});

Vue.config.productionTip = false;
Vue.prototype.$title = browserTitle;

// 确保在创建 Vue 实例前所有的插件都已经被注册
const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
})

// 最后再挂载
app.$mount("#app");


if (!localStorage.getItem("nanoId")) {
  localStorage.setItem("nanoId", nanoId());
}
// import locales from "./locale/index.js";

// getUserInfo()
//   .then(({ userInfo, userLang }) => {
//     i18n.locale = userLang;
//   })
//   .catch(err => {});
